const ROOT_APP = "customer";
const PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL || "http://localhost:3001";
const CUSTOMER_PUBLIC_URL = process.env.REACT_APP_CUSTOMER_URL || PUBLIC_URL;

const config = {
  siteName: "Beauti",
  siteAddress: "3/100 Sunshine Road Brisbane 4000 07 3000 000",
  rootApp: ROOT_APP,
  siteUrl: CUSTOMER_PUBLIC_URL,
  baseUrl: CUSTOMER_PUBLIC_URL,
  basePath: "",
  basename: "/login",
  logopath: "/images/logo.png",
  imagepath: "/images/",
  imageOnError: "/images/Frame1.png",
  defaultPath: "/dashboard",
  API_URL: process.env.REACT_APP_API_URL,
  NODE_URL: process.env.REACT_APP_NODE_URL,
  BOOKING_LINK_URL: `${CUSTOMER_PUBLIC_URL}/booking`,
  phone_number_mask: "9999-999-999",
  business_phone_number_mask: "9999-999-999 | 99-9999-9999",
  business_phone_number_nomask: "9999999999",
  phone_number_pattern: /^[0-9]{4}-[0-9]{3}-[0-9]{3}$/,
  business_phone_number_pattern: /^[0-9]{4}-[0-9]{3}-[0-9]{3}|^[0-9]{2}-[0-9]{4}-[0-9]{4}$/,
  business_phone_number_nopattern: /^[0-9]{4}[0-9]{3}[0-9]{3}$/,
  modalOpenTimeOut: 50,
  modalCloseTimeOut: 500,
  app_key: process.env.REACT_APP_LARAVEL_APP_KEY,
  maintain_downtime: process.env.REACT_APP_MAINTENANCE_MODE,
  facebook_app_id: process.env.REACT_APP_FACEBOOK_APP_ID || "",
  google_oauth_client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID || "",
  default_country_code: "+61",
  country_codes: [
    { name: "au", country_name: "Australia", code: "+61", flag: "🇦🇺" },
  ],
};

export default config;
